import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { APP_NAMES } from '../utils/appConstants';
import { makeSelectFeatureToggles } from '../utils/selectors/feature-toggles';
import { useDatadogRum } from '../hooks/useDatadogRum';

const withFeatureFlip = (Component, options) => {
  const { appName } = options;
  return props => {
    const selectFeatureToggles = useMemo(makeSelectFeatureToggles, []);
    const featureToggles = useSelector(selectFeatureToggles);
    // Every route in all three apps is wrapped here, including the landing
    // and loading pages that render no page chrome, so this is where RUM and
    // Browser Logs start.
    useDatadogRum();
    const { isCheckInEnabled, isLoadingFeatureFlags, isPreCheckInEnabled } =
      featureToggles;
    const appEnabled =
      appName === APP_NAMES.PRE_CHECK_IN
        ? isPreCheckInEnabled
        : isCheckInEnabled;

    if (!appEnabled && !isLoadingFeatureFlags) {
      window.location.replace('/');
      return <></>;
    }

    return (
      <>
        <meta name="robots" content="noindex" />
        <Component {...props} {...featureToggles} />
      </>
    );
  };
};

export default withFeatureFlip;
